import moment from 'moment'
import 'moment/locale/ru'

export const hours = () => {
  return ['00'].concat(Array.from({ length: 23 }, (_, i) => `${i >= 9 ? i + 1 : `0${i + 1}`}`))
}

export const minute = () => {
  return ['00'].concat(Array.from({ length: 59 }, (_, i) => `${i >= 9 ? i + 1 : `0${i + 1}`}`))
}

export const modes = {
  0: 'Неизвестно',
  1: 'Радиопульт',
  2: 'Панель приборов',
  3: 'BT',
  4: 'ДТМФ',
  5: 'Облако',
  6: 'Таймер',
  7: 'Куранты',
}

export const baseUrl = 'https://vm-66693fff.na4u.ru/';

const parseDeviceLastOnline = (lastOnline) => {
  if (!lastOnline) return null
  return moment(lastOnline).add(-3, 'hours')
}

export const getDeviceOnlineStatus = (lastOnline) => {
  const lastOnlineMoment = parseDeviceLastOnline(lastOnline)
  if (!lastOnlineMoment) return 'gray'

  const diffMinutes = moment().diff(lastOnlineMoment) / 60000

  if (diffMinutes < 1) return 'green'
  if (diffMinutes < 4) return 'yellow'
  return 'gray'
}

export const formatDeviceLastOnline = (lastOnline) => {
  const lastOnlineMoment = parseDeviceLastOnline(lastOnline)
  if (!lastOnlineMoment) return null

  return lastOnlineMoment.locale('ru').fromNow()
}
